(function () {
  /**
   * Desktop nav fixes for Impulse + Starfire:
   * 1) Stop Impulse summary handlers that preventDefault and navigate to
   *    summary.dataset.link when Liquid never sets data-link (→ "undefined").
   * 2) Nested flyouts (inside the open dropdown / megamenu) open on summary
   *    click only — top-level items still open on hover.
   * 3) Keep the parent open while interacting with the dropdown; don't let
   *    document-level Impulse click handlers fight link navigation.
   */

  function bindTopLevelSummaries(root) {
    (root || document).querySelectorAll('.site-nav__details > summary').forEach(function (summary) {
      if (summary.hasAttribute('data-starfire-nav')) return;
      summary.setAttribute('data-starfire-nav', '');
      summary.addEventListener(
        'click',
        function (event) {
          // Capture: block Impulse hoverMenu's preventDefault + location=undefined.
          event.stopImmediatePropagation();
        },
        true
      );
    });
  }

  function ensureTopNavOpen(nested) {
    var top = nested.closest('.site-nav__details');
    if (top && !top.hasAttribute('open')) {
      top.setAttribute('open', '');
      top.setAttribute('aria-expanded', 'true');
    }
  }

  function closeSiblingNestedDetails(nested) {
    var parent = nested.parentElement;
    if (!parent) return;
    parent.querySelectorAll(':scope > details').forEach(function (sibling) {
      if (sibling !== nested) sibling.removeAttribute('open');
    });
  }

  function bindNestedClickToggle(root) {
    (root || document).querySelectorAll('.site-nav__dropdown details').forEach(function (nested) {
      if (nested.hasAttribute('data-starfire-nested-click')) return;
      nested.setAttribute('data-starfire-nested-click', '');

      var summary = nested.querySelector(':scope > summary');
      if (!summary) return;

      summary.addEventListener('click', function (event) {
        ensureTopNavOpen(nested);
        event.stopPropagation();
      });

      nested.addEventListener('toggle', function () {
        if (!nested.open) return;
        ensureTopNavOpen(nested);
        closeSiblingNestedDetails(nested);
        var menu = nested.closest('.site-nav__dropdown:not(.megamenu)');
        if (menu) {
          window.requestAnimationFrame(function () {
            sizeAccordionMenu(menu);
          });
        }
      });
    });
  }

  function navLinkFromEvent(event) {
    var target = event.target;
    if (!target || !target.closest) return null;
    // Only real destination links — not summary chevrons / buttons.
    var link = target.closest('.site-nav a[href], .megamenu a[href]');
    if (!link) return null;
    if (link.closest('summary')) return null;
    var href = link.getAttribute('href');
    if (!href || href === '#' || href.indexOf('javascript:') === 0) return null;
    return link;
  }

  function holdOpenForLink(link) {
    var detail = link && link.closest('.site-nav__details');
    if (!detail) return null;
    detail.setAttribute('open', '');
    detail.setAttribute('aria-expanded', 'true');
    detail.setAttribute('data-starfire-nav-holding', '');
    window.clearTimeout(detail._starfireHoldTimer);
    detail._starfireHoldTimer = window.setTimeout(function () {
      detail.removeAttribute('data-starfire-nav-holding');
    }, 600);
    return detail;
  }

  function navigateNavLink(link, event) {
    if (!link) return false;
    // Allow modified / non-primary clicks (new tab, etc.).
    if (event && (event.button > 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey)) {
      return false;
    }
    var href = link.getAttribute('href');
    if (!href) return false;
    holdOpenForLink(link);
    if (event) {
      event.preventDefault();
      event.stopPropagation();
      if (typeof event.stopImmediatePropagation === 'function') {
        event.stopImmediatePropagation();
      }
    }
    // assign() so Safari can't lose the navigation when details closes mid-gesture.
    window.location.assign(href);
    return true;
  }

  function bindLinkClickGuards(root) {
    // Document-level once: Safari closes <details> on mouseleave between
    // mousedown and click, which eats the first press. Navigate on mousedown.
    if (!document.documentElement.hasAttribute('data-starfire-nav-link-doc')) {
      document.documentElement.setAttribute('data-starfire-nav-link-doc', '');

      document.addEventListener(
        'mousedown',
        function (event) {
          var link = navLinkFromEvent(event);
          if (!link) return;
          // Only force-nav when the link lives under an open hover dropdown /
          // megamenu — plain top-level <a> items can use native behavior.
          if (!link.closest('.site-nav__dropdown, .megamenu')) return;
          navigateNavLink(link, event);
        },
        true
      );

      // Keyboard / fallback if mousedown was skipped.
      document.addEventListener(
        'click',
        function (event) {
          var link = navLinkFromEvent(event);
          if (!link) return;
          if (!link.closest('.site-nav__dropdown, .megamenu')) return;
          // If mousedown already navigated, this is a no-op race; still stop
          // Impulse document listeners from toggling aria / closing menus.
          holdOpenForLink(link);
          event.stopPropagation();
          if (typeof event.stopImmediatePropagation === 'function') {
            event.stopImmediatePropagation();
          }
          if (!event.defaultPrevented) {
            navigateNavLink(link, event);
          }
        },
        true
      );
    }

    (root || document).querySelectorAll('.site-nav__details').forEach(function (detail) {
      if (detail.hasAttribute('data-starfire-link-guard')) return;
      detail.setAttribute('data-starfire-link-guard', '');

      detail.addEventListener(
        'pointerdown',
        function (event) {
          var link = navLinkFromEvent(event);
          if (!link || !detail.contains(link)) return;
          holdOpenForLink(link);
        },
        true
      );
    });
  }

  function bindHoverGuards(root) {
    (root || document).querySelectorAll('.site-nav__details[data-hover="true"]').forEach(function (detail) {
      if (detail.hasAttribute('data-starfire-hover-guard')) return;
      detail.setAttribute('data-starfire-hover-guard', '');

      var closeTimer = 0;

      detail.addEventListener(
        'mouseleave',
        function (event) {
          // Kill Impulse's immediate close — Safari loses the pending click.
          event.stopImmediatePropagation();
          window.clearTimeout(closeTimer);

          if (detail.hasAttribute('data-starfire-nav-holding')) return;

          var to = event.relatedTarget;
          if (to && detail.contains(to)) return;

          // Longer delay than Impulse so mousedown→navigate can finish first.
          closeTimer = window.setTimeout(function () {
            if (detail.matches(':hover')) return;
            if (detail.hasAttribute('data-starfire-nav-holding')) return;
            detail.removeAttribute('open');
            detail.setAttribute('aria-expanded', 'false');
            detail.querySelectorAll('details[open]').forEach(function (nested) {
              nested.removeAttribute('open');
            });
          }, 400);
        },
        true
      );

      detail.addEventListener('mouseenter', function () {
        window.clearTimeout(closeTimer);
      });

      detail.addEventListener('mouseover', function () {
        window.clearTimeout(closeTimer);
        if (!detail.hasAttribute('open')) {
          detail.setAttribute('open', '');
          detail.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  function neutralizeFlyoutMeasure(root) {
    (root || document)
      .querySelectorAll('.site-nav__dropdown:not(.megamenu) .site-nav__deep-dropdown-trigger')
      .forEach(function (trigger) {
        if (trigger.hasAttribute('data-starfire-flyout')) return;
        trigger.setAttribute('data-starfire-flyout', '');
        trigger.addEventListener('mouseenter', function () {
          var dropdown = trigger.querySelector(':scope > details > .site-nav__deep-dropdown');
          if (!dropdown) {
            dropdown = trigger.querySelector('.site-nav__deep-dropdown');
          }
          if (!dropdown) return;
          window.requestAnimationFrame(function () {
            dropdown.style.width = '';
            dropdown.classList.remove('site-nav__deep-dropdown--wrap');
            var menu = trigger.closest('.site-nav__dropdown:not(.megamenu)');
            if (menu) sizeAccordionMenu(menu);
          });
        });
      });
  }

  function isVisibleNestedList(list, menu) {
    var node = list.parentElement;
    while (node && node !== menu) {
      if (node.tagName === 'DETAILS' && !node.open) return false;
      node = node.parentElement;
    }

    var style = window.getComputedStyle(list);
    if (style.position === 'absolute' || style.display === 'none' || style.visibility === 'hidden') {
      return false;
    }

    var rect = list.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0;
  }

  function sizeAccordionMenu(menu) {
    if (!menu || menu.classList.contains('megamenu')) return;

    menu.querySelectorAll('.site-nav__deep-dropdown').forEach(function (list) {
      list.style.width = '';
      list.style.maxWidth = '';
    });

    var nested = Array.prototype.filter.call(
      menu.querySelectorAll('details[open] > .site-nav__deep-dropdown'),
      function (list) {
        return isVisibleNestedList(list, menu);
      }
    );

    if (!nested.length) {
      menu.style.width = '';
      return;
    }

    nested.forEach(function (list) {
      list.style.width = 'max-content';
      list.style.maxWidth = 'none';
    });
    menu.style.width = 'max-content';

    var width = menu.scrollWidth;
    nested.forEach(function (list) {
      width = Math.max(width, list.scrollWidth);
    });

    nested.forEach(function (list) {
      list.style.width = '';
      list.style.maxWidth = '';
    });
    menu.style.width = Math.ceil(width) + 'px';
  }

  function bindAccordionWidth(root) {
    (root || document).querySelectorAll('.site-nav__dropdown:not(.megamenu)').forEach(function (menu) {
      if (menu.hasAttribute('data-starfire-width')) return;
      menu.setAttribute('data-starfire-width', '');
      menu.addEventListener(
        'toggle',
        function () {
          window.requestAnimationFrame(function () {
            sizeAccordionMenu(menu);
          });
        },
        true
      );
    });
  }

  function init(root) {
    bindTopLevelSummaries(root);
    bindHoverGuards(root);
    bindNestedClickToggle(root);
    bindLinkClickGuards(root);
    neutralizeFlyoutMeasure(root);
    bindAccordionWidth(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
